// Geometry of the "onda" wordmark, shared by the SVG logo and the dotted footer wordmark.
// Every letter is a stroke of WORDMARK_STROKE units drawn on a 168 x 50 grid.
export const WORDMARK_VIEWBOX: [number, number] = [168, 50]

export const WORDMARK_STROKE = 7

export const WORDMARK_PATHS: Array<string> = [
    'M3.5 32a14.5 14.5 0 1 0 29 0a14.5 14.5 0 1 0 -29 0',
    'M47.5 50V14',
    'M47.5 32a14.5 14.5 0 0 1 29 0V50',
    'M91.5 32a14.5 14.5 0 1 0 29 0a14.5 14.5 0 1 0 -29 0',
    'M120.5 0V50',
    'M135.5 32a14.5 14.5 0 1 0 29 0a14.5 14.5 0 1 0 -29 0',
    'M164.5 14V50'
]

// The mark: a ring holding a single wave.
export const MARK_WAVE_PATH = 'M6.5 12c1.65-2.8 3.85-2.8 5.5 0s3.85 2.8 5.5 0'
